import type { DashboardData } from "./api";

interface PulseProps {
  pulse: DashboardData["pulse"] | null;
}

export function Pulse({ pulse }: PulseProps) {
  if (!pulse) return null;

  const trendUp = pulse.trend_pct >= 0;

  return (
    <div className="cx-admin-pulse">
      <span>
        <strong>{pulse.messages_today}</strong> messages today
      </span>
      <span>
        <strong>{pulse.users_today}</strong> active users
      </span>
      {pulse.trend_pct !== 0 && (
        <span className={trendUp ? "cx-admin-pulse-up" : "cx-admin-pulse-down"}>
          {trendUp ? "\u25B2" : "\u25BC"} {Math.abs(pulse.trend_pct)}% vs last week
        </span>
      )}
    </div>
  );
}
